import { FC } from "react"
import { UserbotPage } from "./userbotPage"
import { RolesTable } from "../components"

export const RolesPage: FC = () => (
  <UserbotPage title="Роли (пулы клиентов)">
    <RolesTable />
  </UserbotPage>
)
